function getTranslation(translationMap, language, field) {
    if (field) {
        return translationMap?.[language]?.[field];
    } 

    return translationMap?.[language];
}

export function getFallback(translationMap, field, selectedLanguage, defaultLanguage, showFallbacks = false) {
    const languages = [selectedLanguage, defaultLanguage, 'en', ...Object.keys(translationMap)];

    for (const language of languages) {
        const t = getTranslation(translationMap, language, field);

        if (t) {
            return `${t}${showFallbacks ? ` (fallback: ${language})` : ''}`;
        }
    }

    return '';
}

export default {
    getFallback,
}